import {Field} from 'formik';
import styled from 'styled-components';
import React from "react";
import {typeSF18r} from "../../styles/typefaces";
import colors from "../../styles/colors";

const Label = styled.label`
  display: block;
  > span {
    ${typeSF18r};
    margin-bottom: 5px;
    display: block;
  }
`;

const CustomField = styled(Field)`
  border: 1px solid ${colors.grey};
  padding: 10px 20px;
  width: 100%;
  ${typeSF18r};
`;

const FieldContainer = styled.div`
  border: 1px solid ${colors.grey};
  padding: 10px 20px;
  width: 100%;
  ${typeSF18r};
`;

const Container = styled.div`
`;

export default ({label, children, className, ...props}) => (
  <Container className={className}>
    <Label>
      <span>{label}</span>
      {children ? (
        <FieldContainer>
          {children}
        </FieldContainer>
      ) : (
        <CustomField {...props}/>
      )}
    </Label>
  </Container>
);


// WEBPACK FOOTER //
// ./src/shared/forms/Field.js